import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'

import MarketplaceApp from '../components/Marketplace/MarketplaceApp'
import MarketplaceLanding from '../components/Marketplace/MarketplaceLanding'

export default function AppRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<MarketplaceLanding />} />
        <Route path="/:chain/:marketAddress" element={<MarketplaceApp />} />
        <Route path="/:chain/:marketAddress/item/:tokenId" element={<MarketplaceApp />} />
        <Route path="*" element={<MarketplaceLanding />} />
      </Routes>
    </BrowserRouter>
  )
}
